import React from 'react'
import PropTypes from 'prop-types'
import TickGreenIcon from '@components/Icon/TickGreen'
import SnowflakeIcon from '@components/Icon/Snowflake'
import BlockIcon from '@components/Icon/Block'
import PowerButtonGreenIcon from '@components/Icon/PowerButtonGreen'
import PowerButtonBlueIcon from '@components/Icon/PowerButtonBlue'
import TickBlueIcon from '@components/Icon/TickBlue'
import classNames from 'classnames'
import { observer, inject } from 'mobx-react'

const ExpertStatusIcon = ({
  expertStatusId,
  staticData,
  expertView,
  expertSearch,
  eplView
}) => {
  let iconComponent = null

  const { EXPERT_STATUSES } = staticData.CONST

  const classes = classNames({
    'expert-status-icon': true,
    'expert-status-icon__vertical-align': expertView,
    'expert-status-icon__expert-search': expertSearch,
    'expert-status-icon__epl-view': eplView
  })

  switch (expertStatusId) {
    case EXPERT_STATUSES.DO_NOT_CONTACT:
      iconComponent = <BlockIcon noClick />
      break

    case EXPERT_STATUSES.COLD_PROSPECT:
      iconComponent = <SnowflakeIcon noClick />
      break

    case EXPERT_STATUSES.WARM_PROSPECT:
      iconComponent = <TickBlueIcon noClick />
      break

    case EXPERT_STATUSES.DORMANT_PROSPECT:
      iconComponent = <PowerButtonBlueIcon noClick />
      break

    case EXPERT_STATUSES.ACTIVE_EXPERT:
      iconComponent = <TickGreenIcon noClick />
      break

    case EXPERT_STATUSES.DORMANT_EXPERT:
      iconComponent = <PowerButtonGreenIcon noClick />
      break

    default:
      break
  }

  return <div className={classes}>{iconComponent}</div>
}

ExpertStatusIcon.propTypes = {
  expertStatusId: PropTypes.number.isRequired,
  staticData: PropTypes.object.isRequired,
  expertView: PropTypes.bool,
  expertSearch: PropTypes.bool,
  eplView: PropTypes.bool
}

export default inject('staticData')(observer(ExpertStatusIcon))
